// GENERATED from scripts/voices.json — a test keeps this copy in sync. Edit the json, then copy.
export const VOICES_VERSION = 1;
export const DEFAULT_VOICE = 'en-US-AriaNeural';
export const PERSONA_VOICES: Readonly<Record<string, Readonly<Record<'en' | 'fr' | 'es', string>>>> = {
  'amara': {
    'en': 'en-US-AnaNeural',
    'fr': 'fr-FR-EloiseNeural',
    'es': 'es-CO-SalomeNeural'
  },
  'mateo': {
    'en': 'en-US-EricNeural',
    'fr': 'fr-CA-AntoineNeural',
    'es': 'es-US-AlonsoNeural'
  },
  'layla': {
    'en': 'en-US-MichelleNeural',
    'fr': 'fr-FR-VivienneMultilingualNeural',
    'es': 'es-PE-CamilaNeural'
  },
  'kenji': {
    'en': 'en-US-GuyNeural',
    'fr': 'fr-FR-RemyMultilingualNeural',
    'es': 'es-ES-AlvaroNeural'
  },
  'priya': {
    'en': 'en-IN-NeerjaNeural',
    'fr': 'fr-BE-CharlineNeural',
    'es': 'es-CL-CatalinaNeural'
  },
  'oliver': {
    'en': 'en-GB-ThomasNeural',
    'fr': 'fr-BE-GerardNeural',
    'es': 'es-CL-LorenzoNeural'
  },
  'marisol': {
    'en': 'en-US-JennyNeural',
    'fr': 'fr-FR-DeniseNeural',
    'es': 'es-MX-DaliaNeural'
  },
  'kofi': {
    'en': 'en-NG-AbeoNeural',
    'fr': 'fr-FR-HenriNeural',
    'es': 'es-AR-TomasNeural'
  },
  'karim': {
    'en': 'en-US-RogerNeural',
    'fr': 'fr-CH-FabriceNeural',
    'es': 'es-CO-GonzaloNeural'
  },
  'hannah': {
    'en': 'en-GB-MaisieNeural',
    'fr': 'fr-CH-ArianeNeural',
    'es': 'es-US-PalomaNeural'
  },
  'wei': {
    'en': 'en-GB-RyanNeural',
    'fr': 'fr-CA-JeanNeural',
    'es': 'es-MX-JorgeNeural'
  },
  'fatima': {
    'en': 'en-GB-SoniaNeural',
    'fr': 'fr-CA-SylvieNeural',
    'es': 'es-ES-ElviraNeural'
  }
};

import type { Locale } from './banks.js';

/** The default Edge neural voice for a persona in a locale; undefined for an unknown persona. */
export function voiceFor(personaId: string, locale: Locale): string | undefined {
  return PERSONA_VOICES[personaId]?.[locale];
}
